import React, { useState } from "react";
import { adminApi } from "../../utils/axiosConfig";
import styled from "styled-components";

// STYLES
const Form = styled.form`
  margin-top: 1rem;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

const Select = styled.select`
  padding: 0.5rem 1rem;
  border-radius: 30px;
  border: 2px solid #cbd5e0;
  font-size: 0.95rem;
  outline: none;
  background-color: #f7fafc;
  transition: border-color 0.3s ease;

  &:focus {
    border-color: #38b2ac;
    box-shadow: 0 0 0 3px rgba(56, 178, 172, 0.2);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const SubmitButton = styled.button`
  padding: 0.5rem 1.2rem;
  border: none;
  border-radius: 999px;
  background-color: #3182ce;
  color: white;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #2b6cb0;
  }

  &:disabled {
    background-color: #90cdf4;
    cursor: not-allowed;
  }
`;

const ErrorText = styled.p`
  color: #e53e3e;
  margin-top: 0.5rem;
  font-size: 0.9rem;
`;

export default function ModifyCommande({ orderId, currentStatus, onUpdate }) {
  const [status, setStatus] = useState(currentStatus?.toLowerCase() || "en attente");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const res = await adminApi.put(
        `/api/admin/orders/update`,
        { orderId, status: status.toLowerCase() }
      );
      if (res.data.success) {
        onUpdate(res.data.order);
      }
    } catch (err) {
      setError(err.response?.data?.message || "Erreur lors de la mise à jour");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <Select value={status} onChange={(e) => setStatus(e.target.value)} disabled={loading}>
          <option value="en attente">En attente</option>
          <option value="en cours">En cours</option>
          <option value="expédiée">Expédiée</option>
          <option value="livrée">Livrée</option>
          <option value="annulée">Annulée</option>
        </Select>
        <SubmitButton type="submit" disabled={loading}>
          {loading ? "Modification..." : "Modifier"}
        </SubmitButton>
      </Form>
      {error && <ErrorText>{error}</ErrorText>}
    </>
  );
}
